// Aceitería Ahillos — comportamiento del tema (portado del prototipo, cesta con la API AJAX de Shopify)

document.addEventListener('DOMContentLoaded', () => {

  // ===== animación de entrada (portada, en cada carga) =====
  // el imagotipo se dibuja en el centro y viaja a la izquierda del nombre de la cabecera
  const intro = document.getElementById('intro');
  if (!intro) document.documentElement.classList.remove('intro-on'); // sin animación no debe quedar bloqueado el scroll
  if (intro) {
    const root = document.documentElement;
    if (root.classList.contains('no-intro')) {
      intro.remove();
      root.classList.remove('intro-on');
    } else {
      window.scrollTo(0, 0); // la animación siempre empieza arriba del todo
      const lockup = intro.querySelector('.intro-lockup');
      const icon = document.querySelector('.nav .brand-icon');
      setTimeout(() => {
        // destino: el hueco real del imagotipo en la cabecera (a la izquierda del nombre)
        if (icon && lockup) {
          const t = icon.getBoundingClientRect();
          const l = lockup.getBoundingClientRect();
          lockup.style.setProperty('--dx', ((t.left + t.width / 2) - (l.left + l.width / 2)) + 'px');
          lockup.style.setProperty('--dy', ((t.top + t.height / 2) - (l.top + l.height / 2)) + 'px');
        }
        intro.classList.add('go');
        root.classList.add('intro-go'); // el nombre pasa a blanco como el resto de la cabecera
        // al aterrizar: aparece el logo de la cabecera y se retira la capa
        setTimeout(() => {
          root.classList.remove('intro-on');
          intro.classList.add('done');
          setTimeout(() => intro.remove(), 400);
        }, 1000);
      }, 2100);
    }
  }

  // ===== barra superior: sólida al hacer scroll (en la portada) =====
  const top = document.getElementById('top');
  if (top) {
    if (top.hasAttribute('data-solid')) {
      top.classList.add('onlight');
    } else {
      const onScroll = () => top.classList.toggle('solid', window.scrollY > window.innerHeight * 0.72);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  // ===== menú móvil =====
  const burger = document.getElementById('burger');
  const mob = document.getElementById('mobmenu');
  if (burger && mob) {
    const barra = document.getElementById('top');
    const velo = document.createElement('div'); // atenúa la home que queda detrás
    velo.className = 'mobmenu-scrim';
    document.body.appendChild(velo);
    const cerrar = () => {
      mob.classList.remove('open');
      velo.classList.remove('show');
      if (barra) barra.classList.remove('menu-open');
      burger.setAttribute('aria-expanded', 'false');
    };
    velo.addEventListener('click', cerrar);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && mob.classList.contains('open')) cerrar(); });
    burger.addEventListener('click', () => {
      if (mob.classList.contains('open')) { cerrar(); return; }
      // el círculo nace en el centro del botón "Menú" y crece hasta cubrir todo el panel
      const nav = document.querySelector('.nav');
      mob.style.setProperty('--mtop', ((nav ? nav.getBoundingClientRect().top : 33) + 8) + 'px'); // el panel arranca bajo la barra roja
      const b = burger.getBoundingClientRect();
      const m = mob.getBoundingClientRect();
      const x = b.left + b.width / 2 - m.left;
      const y = b.top + b.height / 2 - m.top;
      const r = Math.hypot(Math.max(x, m.width - x), Math.max(y, m.height - y));
      mob.style.setProperty('--mx', x + 'px');
      mob.style.setProperty('--my', y + 'px');
      mob.style.setProperty('--mr', Math.ceil(r) + 'px');
      mob.classList.add('open');
      velo.classList.add('show');
      if (barra) barra.classList.add('menu-open');
      burger.setAttribute('aria-expanded', 'true');
    });
    mob.querySelectorAll('a').forEach(a => a.addEventListener('click', cerrar));
  }

  // ===== flechas del carrusel de productos =====
  const rail = document.getElementById('rail');
  const prev = document.getElementById('prev');
  const next = document.getElementById('next');
  if (rail && prev && next) {
    // las flechas avanzan de tarjeta en tarjeta y nunca más allá de la última (ni antes de la primera)
    const tope = () => rail.scrollWidth - rail.clientWidth;
    const inicio = () => { const c = rail.querySelector('.pcard'); return c ? c.offsetLeft : 0; };
    const ir = dir => {
      if (tope() <= 40) return; // caben todas: nada que recorrer
      const pos = rail.scrollLeft, base = inicio();
      const pos_tarjetas = [...rail.querySelectorAll('.pcard')].map(c => c.offsetLeft - base);
      let destino;
      if (dir > 0) { const sig = pos_tarjetas.find(x => x > pos + 4); destino = sig === undefined ? tope() : sig; }
      else { const ant = [...pos_tarjetas].reverse().find(x => x < pos - 4); destino = ant === undefined ? 0 : ant; }
      rail.scrollTo({ left: Math.max(0, Math.min(destino, tope())), behavior: 'smooth' });
    };
    const estado = () => {
      const hayRecorrido = tope() > 40; // si caben todas, las flechas no se desactivan
      prev.disabled = hayRecorrido && rail.scrollLeft <= 4;
      next.disabled = hayRecorrido && rail.scrollLeft >= tope() - 4;
    };
    next.onclick = () => ir(1);
    prev.onclick = () => ir(-1);
    rail.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  }

  // ===== aviso (toast) =====
  let tm;
  const toast = document.getElementById('toast');
  function notify(m) {
    if (!toast) return;
    toast.textContent = m;
    toast.classList.add('show');
    clearTimeout(tm);
    tm = setTimeout(() => toast.classList.remove('show'), 2100);
  }

  // ===== cesta lateral con la API AJAX de Shopify =====
  const cfg = window.themeCartConfig || { currency: 'EUR', locale: 'es' };
  const fmt = new Intl.NumberFormat(cfg.locale || 'es', { style: 'currency', currency: cfg.currency || 'EUR' });
  const money = cents => fmt.format(cents / 100).replace(/\s/g, ' ');
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  const cc = document.getElementById('cc');
  const cartItemsEl = document.getElementById('cartItems');
  const cartEmptyEl = document.getElementById('cartEmptyState');
  const cartFootEl = document.getElementById('cartFoot');
  const cartCrossEl = document.getElementById('cartCross');
  const cartSubtotalEl = document.getElementById('cartSubtotal');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartScrim = document.getElementById('cartScrim');

  let suggestions = [];
  try { suggestions = JSON.parse(document.getElementById('cartSuggestions').textContent); } catch (e) { /* sin sugerencias */ }

  let currentCart = null;

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    currentCart = await r.json();
    renderCart();
    return currentCart;
  }

  function itemName(item) {
    return item.product_title + (item.variant_title ? ' · ' + item.variant_title : '');
  }

  function renderCart() {
    const cart = currentCart;
    if (!cart) return;
    if (cc) cc.textContent = cart.item_count;
    if (!cartItemsEl) return;

    cartItemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${esc(item.key)}">
        <a class="cart-item-img" href="${esc(item.url)}">${item.image ? `<img src="${esc(sized(item.image, 160))}" alt="" width="64" height="80">` : ''}</a>
        <div class="cart-item-info">
          <a class="cart-item-name" href="${esc(item.url)}">${esc(itemName(item))}</a>
          <div class="qty" data-qty data-key="${esc(item.key)}">
            <button type="button" data-minus aria-label="Restar">−</button><span>${item.quantity}</span><button type="button" data-plus aria-label="Sumar">+</button>
          </div>
        </div>
        <div class="cart-item-side">
          <button type="button" class="cart-item-remove" data-remove="${esc(item.key)}" aria-label="Eliminar">✕</button>
          <div class="cart-item-price">${money(item.final_line_price)}</div>
        </div>
      </div>`).join('');

    const empty = cart.item_count === 0;
    cartEmptyEl && (cartEmptyEl.hidden = !empty);
    cartFootEl && (cartFootEl.hidden = empty);
    cartItemsEl.hidden = empty;
    if (cartSubtotalEl) cartSubtotalEl.textContent = money(cart.total_price);

    // "también te puede interesar": productos que aún no están en la cesta
    if (cartCrossEl) {
      const inCart = new Set(cart.items.map(i => i.product_id));
      const others = suggestions.filter(s => !inCart.has(s.product_id)).slice(0, 4);
      if (empty || !others.length) {
        cartCrossEl.innerHTML = '';
        cartCrossEl.hidden = true;
      } else {
        cartCrossEl.hidden = false;
        cartCrossEl.innerHTML = `
          <div class="cart-cross-head">También te puede interesar</div>
          <div class="cart-cross-rail">
            ${others.map(s => `
              <div class="cart-cross-item">
                <a href="${esc(s.url)}" class="cart-cross-img">${s.image ? `<img src="${esc(s.image)}" alt="" width="120" height="150">` : ''}</a>
                <div class="cart-cross-name">${esc(s.title)}</div>
                <div class="cart-cross-row"><span class="cart-cross-price">${money(s.price)}</span><button type="button" class="cart-cross-add" data-add-variant="${s.variant_id}" data-silent>Añadir</button></div>
              </div>`).join('')}
          </div>`;
      }
    }
  }

  async function changeLine(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    currentCart = await r.json();
    renderCart();
  }

  async function addVariant(variantId, quantity, name, silent) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      notify(err.description || 'No se ha podido añadir el producto.');
      return;
    }
    await fetchCart();
    if (!silent) notify((name || 'Producto') + ' añadido a la cesta');
  }

  function openCart() {
    if (!cartDrawer) return;
    fetchCart();
    cartDrawer.classList.add('open');
    cartScrim && cartScrim.classList.add('show');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-lock');
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartScrim && cartScrim.classList.remove('show');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-lock');
  }

  document.getElementById('cartBtn')?.addEventListener('click', openCart);
  document.getElementById('cartClose')?.addEventListener('click', closeCart);
  cartScrim && cartScrim.addEventListener('click', closeCart);

  // ===== modal "Site Credits" =====
  const creditsModal = document.getElementById('creditsModal');
  const creditsScrim = document.getElementById('creditsScrim');
  function openCredits() {
    if (!creditsModal) return;
    creditsModal.classList.add('show');
    creditsScrim && creditsScrim.classList.add('show');
    creditsModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-lock');
  }
  function closeCredits() {
    if (!creditsModal) return;
    creditsModal.classList.remove('show');
    creditsScrim && creditsScrim.classList.remove('show');
    creditsModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-lock');
  }
  document.getElementById('creditsBtn')?.addEventListener('click', openCredits);
  document.getElementById('creditsClose')?.addEventListener('click', closeCredits);
  creditsScrim && creditsScrim.addEventListener('click', closeCredits);

  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeCredits(); } });

  // ===== clics delegados: añadir / eliminar / cantidad en la cesta =====
  document.addEventListener('click', e => {
    const addBtn = e.target.closest('[data-add-variant]');
    if (addBtn && !addBtn.disabled) {
      let qty = 1;
      if (addBtn.hasAttribute('data-use-qty')) {
        const span = addBtn.closest('.buybox')?.querySelector('[data-qty] span');
        qty = Math.max(1, parseInt(span?.textContent, 10) || 1);
      }
      let variantId = addBtn.dataset.addVariant;
      const select = document.querySelector('[data-variant-select]');
      if (select && addBtn.hasAttribute('data-use-qty')) variantId = select.value;
      addVariant(variantId, qty, addBtn.dataset.name, addBtn.hasAttribute('data-silent'));
      return;
    }
    const removeBtn = e.target.closest('[data-remove]');
    if (removeBtn) { changeLine(removeBtn.dataset.remove, 0); return; }
  });

  cartItemsEl && cartItemsEl.addEventListener('click', e => {
    const box = e.target.closest('[data-qty]');
    if (!box || !currentCart) return;
    const item = currentCart.items.find(i => i.key === box.dataset.key);
    if (!item) return;
    if (e.target.closest('[data-plus]')) changeLine(item.key, item.quantity + 1);
    if (e.target.closest('[data-minus]')) changeLine(item.key, item.quantity - 1);
  });

  // contador de la cabecera al cargar la página
  fetchCart();

  // ===== vídeo de portada: pausado si el usuario prefiere menos movimiento =====
  const heroVideo = document.getElementById('heroVideo');
  if (heroVideo && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    heroVideo.pause();
    heroVideo.removeAttribute('autoplay');
  }

  // ===== aparición suave al hacer scroll =====
  const revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(el => io.observe(el));
    } else {
      revealEls.forEach(el => el.classList.add('in'));
    }
  }

  // ===== ficha de producto: miniaturas de la galería =====
  document.querySelectorAll('.pdp .thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      const main = document.getElementById('pdpMainImg');
      if (!main || !btn.dataset.full) return;
      document.querySelectorAll('.pdp .thumb').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      main.src = btn.dataset.full;
      if (btn.dataset.w) main.width = btn.dataset.w;
      if (btn.dataset.h) main.height = btn.dataset.h;
    });
  });

  // ===== ficha de producto: selector de cantidad =====
  document.querySelectorAll('.buybox [data-qty]').forEach(box => {
    const span = box.querySelector('span');
    let n = 1;
    box.querySelector('[data-minus]')?.addEventListener('click', () => { n = Math.max(1, n - 1); span.textContent = n; });
    box.querySelector('[data-plus]')?.addEventListener('click', () => { n = Math.min(20, n + 1); span.textContent = n; });
  });

  // ===== ficha de producto: cambio de formato (variante) =====
  document.querySelector('[data-variant-select]')?.addEventListener('change', e => {
    const opt = e.target.selectedOptions[0];
    if (opt && opt.dataset.url) window.location.href = opt.dataset.url;
  });
});

// ===== banner que invita a comprar: aparece tras la animación de entrada y se puede cerrar =====
document.addEventListener('DOMContentLoaded', () => {
  const promo = document.getElementById('promo');
  if (!promo) return;
  let cerrado = false;
  try { cerrado = sessionStorage.getItem('ahillos_promo') === '1'; } catch (e) { /* sin almacenamiento */ }
  if (cerrado) { promo.remove(); return; }
  const enPortada = !!document.getElementById('intro');
  setTimeout(() => promo.classList.add('show'), enPortada ? 4600 : 2500);
  promo.querySelector('.promo-x').addEventListener('click', () => {
    promo.classList.remove('show');
    try { sessionStorage.setItem('ahillos_promo', '1'); } catch (e) { /* sin almacenamiento */ }
    setTimeout(() => promo.remove(), 700);
  });
});

// ===== "De la sierra a tu cocina": bloques plegables en móvil, siempre abiertos en escritorio =====
document.addEventListener('DOMContentLoaded', () => {
  const titulos = document.querySelectorAll('.kitchen .block .k');
  if (!titulos.length) return;
  const escritorio = window.matchMedia('(min-width: 960px)');
  const aplicar = () => titulos.forEach(k => {
    const bloque = k.parentElement;
    if (escritorio.matches) {
      bloque.classList.remove('open');
      ['role', 'tabindex', 'aria-expanded'].forEach(a => k.removeAttribute(a));
    } else {
      k.setAttribute('role', 'button');
      k.setAttribute('tabindex', '0');
      k.setAttribute('aria-expanded', String(bloque.classList.contains('open')));
    }
  });
  const alternar = k => {
    if (escritorio.matches) return;
    const abierto = k.parentElement.classList.toggle('open');
    k.setAttribute('aria-expanded', String(abierto));
  };
  titulos.forEach(k => {
    k.addEventListener('click', () => alternar(k));
    k.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); alternar(k); } });
  });
  escritorio.addEventListener('change', aplicar);
  aplicar();
});

// ===== menú desplegable de "Tienda": se abre al pasar el ratón por el enlace y se cierra al salir =====
document.addEventListener('DOMContentLoaded', () => {
  const gatillo = document.querySelector('.nav a.has-mega');
  const mega = document.getElementById('mega');
  const barra = document.getElementById('top');
  if (!gatillo || !mega || !barra) return;
  let espera;
  const abrir = () => { clearTimeout(espera); barra.classList.add('mega-open'); mega.setAttribute('aria-hidden', 'false'); };
  const cerrar = () => { espera = setTimeout(() => { barra.classList.remove('mega-open'); mega.setAttribute('aria-hidden', 'true'); }, 140); };
  [gatillo, mega].forEach(el => { el.addEventListener('mouseenter', abrir); el.addEventListener('mouseleave', cerrar); });
  gatillo.addEventListener('focus', abrir);
  mega.addEventListener('focusout', e => { if (!mega.contains(e.relatedTarget) && e.relatedTarget !== gatillo) cerrar(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') cerrar(); });
});

// ===== enlace "← Volver": regresa a la página anterior si venimos de dentro del sitio; si no, va a su enlace =====
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-back]').forEach(a => a.addEventListener('click', e => {
    const interno = document.referrer && document.referrer.indexOf(location.origin) === 0;
    if (interno && history.length > 1) { e.preventDefault(); history.back(); }
  }));
});
